var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup1488(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1488",
    "data-name": "Group 1488",
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.003,
    height: 42.003,
    viewBox: "0 0 42.003 42.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_787",
    "data-name": "Path 787",
    d: "M16.867,0C9.571.059,5.57.44,2.94,3.07,1.139,4.871.393,7.315.083,11.02H9.522Z",
    transform: "translate(0.136 0.006)",
    fill: "#afafaf"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_788",
    "data-name": "Path 788",
    d: "M.056,5.4C0,7.372,0,9.628,0,12.225c0,9.9,0,14.85,3.076,17.926S11.1,33.227,21,33.227s14.85,0,17.926-3.076S42,22.126,42,12.225c0-2.6,0-4.854-.055-6.825Z",
    transform: "translate(0 8.776)",
    fill: "#afafaf"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    "data-name": "Path 789",
    d: "M25.011,10.63c-.309-3.7-1.056-6.149-2.857-7.95A9.282,9.282,0,0,0,17.246.243L10.321,10.63Z",
    transform: "translate(16.774 0.395)",
    fill: "#afafaf"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_790",
    "data-name": "Path 790",
    d: "M22.214.184C19.671,0,16.554,0,12.679,0h-.207L5.121,11.026h9.865Z",
    transform: "translate(8.323 0)",
    fill: "#afafaf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1488);
export default __webpack_public_path__ + "static/media/Group 1488.e74119f5474608fb98c53ed2b62c204a.svg";
export { ForwardRef as ReactComponent };